import { call, put, takeLatest, select } from 'typed-redux-saga'
import { MIN_FIND_LENGTH } from 'Constants/Global'
import { FormNames } from 'Constants/FormNames'
import { errorHandler, loadersSlice, NOTIFICATION_TYPE, notifyMessageCreator } from 'Modules'

import {
	orderEditSelectors,
	outOfficeRegistratorCabinetApi,
	outOfficeRegistratorCabinetNS,
	outOfficeRegistratorCabinetSlice,
} from 'Pages/registratorCabinet'

function* getRegionsCities(action: outOfficeRegistratorCabinetNS.getCities) {
	try {
		const { params } = action.payload
		yield* call(outOfficeRegistratorCabinetApi.getCitiesRegions, params)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* getSlots(action: outOfficeRegistratorCabinetNS.getSlots) {
	try {
		const { params } = action.payload
		yield* call(outOfficeRegistratorCabinetApi.getSlots, params)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* getAddressSaga(action: outOfficeRegistratorCabinetNS.getAddress) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const query = action.payload?.query ?? ''
		if (query?.length > MIN_FIND_LENGTH) {
			const res = yield* call(outOfficeRegistratorCabinetApi.getAddress, action.payload)
			yield* put(
				outOfficeRegistratorCabinetSlice.actions.setAddress({
					entries: res,
				})
			)
		}
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}
function* createAppointment(action: outOfficeRegistratorCabinetNS.createAppointment) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(outOfficeRegistratorCabinetApi.createAppointment, action.payload)
	} catch (error) {
		yield* call(errorHandler, error, FormNames.ORDERS.EDIT_ORDER)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* errorNotificationResponse(
	action: outOfficeRegistratorCabinetNS.errorNotificationResponse
) {
	try {
		const order = yield* select(orderEditSelectors.getOne)

		if (order?.online_identification === true) {
			yield* call(notifyMessageCreator, 'cabinet.create_appointment.error.sber_office', {
				options: { type: NOTIFICATION_TYPE.ERROR },
			})
		} else {
			yield* call(notifyMessageCreator, 'cabinet.create_appointment.error.partner_office', {
				options: { type: NOTIFICATION_TYPE.ERROR },
			})
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* outOfficeRegistratorCabinetSaga() {
	yield* takeLatest(
		outOfficeRegistratorCabinetSlice.actions.getRegionsCities.type,
		getRegionsCities
	)
	yield* takeLatest(outOfficeRegistratorCabinetSlice.actions.getSlots.type, getSlots)
	yield* takeLatest(outOfficeRegistratorCabinetSlice.actions.getAddress.type, getAddressSaga)
	yield* takeLatest(
		outOfficeRegistratorCabinetSlice.actions.createAppointment.type,
		createAppointment
	)

	yield* takeLatest(
		outOfficeRegistratorCabinetSlice.actions.errorNotificationResponse.type,
		errorNotificationResponse
	)
}
